(function () {
  const modal = document.querySelector('[data-modal-ativo]');
  if (!modal) return;

  const imgEl   = modal.querySelector('[data-modal-img]');
  const flagEl  = modal.querySelector('[data-modal-flag]');
  const titleEl = modal.querySelector('[data-modal-title]');
  const textEl  = modal.querySelector('[data-modal-text]');
  const cardEl  = modal.querySelector('[data-modal-card]');
  const closeEls = modal.querySelectorAll('[data-modal-close]');

  const triggers = document.querySelectorAll('[data-ativo-key]');
  const ATIVOS = window.__MP_ATIVOS__ || {};

  function open(key) {
    const a = ATIVOS[key];
    if (!a) return;
    imgEl.src = a.img;
    imgEl.alt = a.ativo;
    flagEl.textContent = a.problema;
    titleEl.textContent = a.ativo;
    textEl.textContent = a.texto;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  triggers.forEach((t) => {
    t.addEventListener('click', () => open(t.dataset.ativoKey));
  });

  closeEls.forEach((el) => el.addEventListener('click', close));

  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });

  if (cardEl) {
    cardEl.addEventListener('click', (e) => e.stopPropagation());
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
})();
